import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptBR from "./locales/pt-BR.json";
import enUS from "./locales/en-US.json";

// Phase 8.37 — Idiomas suportados reduzidos para pt-BR + en-US.
// Idioma padrão é herdado da empresa (workspace) — ver `TenantContext` que
// aplica `i18n.changeLanguage(empresa.idioma_padrao)` após login.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "pt-BR": { translation: ptBR },
      "en-US": { translation: enUS },
    },
    fallbackLng: "pt-BR",
    supportedLngs: ["pt-BR", "en-US"],
    interpolation: { escapeValue: false },
    // Precedência: escolha da empresa (localStorage v360.idioma) > navegador.
    // O usuário NÃO troca idioma diretamente — apenas o admin da empresa.
    detection: { order: ["localStorage", "navigator"], caches: [], lookupLocalStorage: "v360.idioma" },
  });

export default i18n;
